exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-upload-preview[data-v-30521784] {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(50%, -50%);\n      -ms-transform: translate(50%, -50%);\n          transform: translate(50%, -50%);\n  width: 180px;\n  height: 180px;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 0 4px #ccc;\n          box-shadow: 0 0 4px #ccc;\n  overflow: hidden;\n}\n.avatar-upload-preview img[data-v-30521784] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
